import axios from 'axios';
import { createSplitProducerQuery } from './queries';

const addSplitProducer = (model) =>
    new Promise((resolve, reject) => {
        const query = createSplitProducerQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                if (errors?.response?.data?.statusCode === 422 && typeof errors?.response?.data?.message === 'string') {
                    reject(new Error(errors.response.data.message));
                    return;
                }
                reject(new Error('Unable to add split producer'));
            });
    });

export default addSplitProducer;
